/* eslint-disable consistent-return */
import styled, { css } from 'styled-components';

import {
  colors,
  spacing,
  transitions,
  typography,
} from '../../../../styles/theme';
import BaseButton from '../../../ui/Button';

export const Container = styled.div`
  margin-bottom: ${spacing('2')};
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: flex-start;
  width: 100%;
`;

export const ItemName = styled.p`
  font-weight: 400;
`;

export const ItemDate = styled.p`
  font-size: 12px;
  color: #6B7280;
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;

export const Row = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-weight: ${typography('weights.light')};
  padding: ${spacing('2')};
  border-bottom: 1px solid ${colors('black.08')};
`;

export const Actions = styled.div`
  display: flex;
`;

export const Button = styled(BaseButton)`
  height: 36px;
  max-height: 36px;
  padding: 0 12px;
  font-weight: 400;
  white-space: nowrap;
  display: grid;
  grid-template-areas: 'stack';
  .spinner {
    grid-area: stack;
    visibility: hidden;
  }
  .text {
    grid-area: stack;
  }
  &.loading {
    .text {
      visibility: hidden;
    }
    .spinner {
      visibility: visible;
    }
}
  &:hover:enabled,
  &:focus:enabled {
    background-color: ${colors('red.base')};
    color: ${colors('white.base')};
  }
`;

export const ActionsBar = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

export const ButtonContent = styled.span`
  display: flex;
  align-items: center;
  gap: 10px;
`;

// @TODO: Utilizar o componente ButtonStyles.ts
export const Link = styled.a`
  font-size: 14px;
  font-weight: 400;
  background-color: ${colors('default.base')};
  color: ${colors('black.base')};
  padding: 10px;
  cursor: pointer;
  margin-left: ${spacing('1')};
  border: none;
  border-radius: 24px;
  text-decoration: none;
  font-family: inherit;
  min-width: 100px;
  text-align: center;
  transition: ${transitions('fast')};
  white-space: nowrap;

  &:not(.disabled-link):hover {
    background-color: ${colors('black.base')};
    color: ${colors('default.base')};
    transition: ${transitions('fast')};
  }

  ${(props) => {
    if (props['aria-disabled']) {
      return css`
        opacity: 0.5;
        cursor: not-allowed;

        :hover,
        :focus {
          background-color: ${colors('default.base')};
          color: ${colors('black.base')};
        }
      `;
    }
  }}
`;
